/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Editor/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import CommsThreadTextarea from 'DesignSystem/CommsThreadTextarea/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Editor({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Editor",
  onChange,
  isSubmitting
  
}) {
let messageComposeMessageValueData = fromData.useDataValue({ viewPath,
context: 'message_compose',
path: 'message',
})
let messageComposeMessageChangeData = fromData.useDataChange({ viewPath,
context: 'message_compose',
path: 'message',
})
let messageComposeMessageIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'message_compose',
})
let threadTypeValueData = fromData.useDataFormat({ viewPath,
context: 'thread',
path: 'type',
format: fromFormat.isInAppMessage,
})
let threadTypeValueData1 = fromData.useDataFormat({ viewPath,
context: 'thread',
path: 'type',
format: fromFormat.isSmsMaxLength,
})
  return (<React.Fragment
>
<CommsThreadTextarea
  viewPath={`${viewPath}/CommsThreadTextarea`}
 data="message_compose.message"
 onChange={messageComposeMessageChangeData}
 value={messageComposeMessageValueData}
 disabled={messageComposeMessageIsSubmittingData}
 data="thread.type"
 format="/Data/format.js isInAppMessage"
 placeholder={threadTypeValueData}
 data="thread.type"
 format="/Data/format.js isSmsMaxLength"
 maxLength={threadTypeValueData1}
/>
{children}
</React.Fragment>)
}